import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getCompanyCodeFromToken, getToken, getUserFromToken } from '../services/authService';
import { useMsal } from "@azure/msal-react";
import { isProduction } from "../services/msalConfig";
import { CheckUserExistsMultiple, GetCompanyByUser } from '../services/apiService';

const Header = ({ toggleSidebar, headerText, headerpage ,extraMb = true }) => {
  const user = getToken();
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const { instance } = useMsal();

  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

const handleCompanyClick = async (company) => {
  if (!company?.companyCode) return;
  try {
    const response = await CheckUserExistsMultiple(
      getUserFromToken(), 
      company.companyCode,
      company.department_id  // ✅ pass department_id
    );
    if (response && response.token) handleLoginSuccess(response.token);
    else console.error("Access denied or no token returned.");
  } catch (error) {
    console.error("Company switch failed:", error);
  }
};

  const handleLoginSuccess = (token) => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("isAuthenticated");
    localStorage.setItem("authToken", token);
    localStorage.setItem("isAuthenticated", "true");
    window.location.href = "/";
  };

  const handleLogout = async () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("ssoAccessDeniedEmail");
    try {
      const accounts = instance?.getAllAccounts?.() || [];
      if (accounts.length > 0) {
        await instance.logoutRedirect({
          account: accounts[0],
          postLogoutRedirectUri: window.location.origin + "/login",
        });
        return;
      }
    } catch (e) {
      console.error("MSAL logout failed", e);
    }
    window.location.href = "/login";
  };

  useEffect(() => {
    const loadCompany = async () => {
      try {
        const data = await GetCompanyByUser();
        setCompanies(data || []);
      } catch (err) {
        console.error("Failed to fetch companies", err);
      }
    };
    loadCompany();
  }, []);

  return (
    <div className="relative w-full">
      {/* Background Image */}
    

      {/* Main Header */}
      <div className="relative ">
        <header className="flex 3xl:px-[8%] 4xl:px-[10%] flex-row items-center justify-between p-3 sm:p-4 text-primary-600 w-full gap-2">
          {/* Left: Hamburger + Logo */}
          <div className="flex items-center flex-shrink-0">
            <button onClick={toggleSidebar} className="text-2xl text-white p-2 sm:mr-2">
              ☰
            </button>
            <Link to="/" className="flex items-center ml-2">
              <img src="../Recruit-Logo.svg" alt="Logo" className="w-auto" />
            </Link>
          </div>

          {/* Right: User Info */}
          {user && (
            <div className="flex items-center space-x-2 sm:space-x-4 relative flex-shrink-0">
              <img
                src={`https://ui-avatars.com/api/?name=${encodeURIComponent(user.unique_name)}`}
                alt="Profile"
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-full cursor-pointer border-2 border-white"
                onClick={toggleDropdown}
              />
              <span
                className="hidden sm:inline text-white cursor-pointer font-semibold text-sm sm:text-base"
                onClick={toggleDropdown}
              >
                {user.unique_name} <span className="ml-1">&#9662;</span>
              </span>

           {isDropdownOpen && (
  <div className="absolute top-full right-0 mt-3 w-[min(18rem,calc(100vw-2rem))] bg-white rounded-2xl overflow-hidden z-50"
    style={{ boxShadow: '0 20px 60px rgba(18, 76, 114, 0.18), 0 4px 16px rgba(18,76,114,0.10)' }}>
    
    {/* Header Strip */}
    <div className="px-4 py-3 flex items-center gap-3"
      style={{ background: 'linear-gradient(135deg, rgb(18,76,114), rgba(18,76,114,0.8))' }}>
      <img
        src={`https://ui-avatars.com/api/?name=${encodeURIComponent(user.unique_name)}&background=ffffff&color=124c72&bold=true`}
        alt="Profile"
        className="w-9 h-9 rounded-full border-2 border-white/40"
      />
      <div>
        <p className="text-white font-semibold text-sm leading-tight">{user.unique_name}</p>
        <p className="text-white/60 text-xs">Manage account</p>
      </div>
    </div>

    <ul className="divide-y" style={{ divideColor: 'rgba(18,76,114,0.08)' }}>
      
      {/* Profile Link */}
      <li>
        <Link to="/profile"
          className="flex items-center gap-3 px-4 py-3 text-sm transition-all hover:bg-blue-50"
          style={{ color: 'rgb(18,76,114)' }}>
          <span className="w-7 h-7 rounded-full flex items-center justify-center text-xs"
            style={{ backgroundColor: 'rgba(18,76,114,0.08)' }}>👤</span>
          <span className="font-medium">My Profile</span>
        </Link>
      </li>

      {/* Section Label */}
      {companies?.length > 0 && (
        <li className="px-4 pt-3 pb-1">
          <span className="text-xs font-semibold tracking-widest uppercase"
            style={{ color: 'rgba(18,76,114,0.4)' }}>Workspaces</span>
        </li>
      )}

      {/* Company Items */}
      {companies?.map((c, idx) => {
        const selectedCompany = getCompanyCodeFromToken();
        const isSelected = selectedCompany === c.companyCode;

        return (
          <li key={idx}>
            <button
              onClick={() => handleCompanyClick(c)}
              className="w-full px-4 py-3 flex items-start gap-3 transition-all text-left"
              style={{
                backgroundColor: isSelected ? 'rgba(18,76,114,0.06)' : 'transparent',
                borderLeft: isSelected ? '3px solid rgb(18,76,114)' : '3px solid transparent'
              }}
              onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.backgroundColor = 'rgba(18,76,114,0.03)'; }}
              onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              {/* Icon */}
              <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5"
                style={{ backgroundColor: isSelected ? 'rgb(18,76,114)' : 'rgba(18,76,114,0.08)' }}>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                  style={{ color: isSelected ? 'white' : 'rgb(18,76,114)' }}>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>

              {/* Text */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-semibold text-sm truncate"
                    style={{ color: isSelected ? 'rgb(18,76,114)' : '#1a1a1a' }}>
                    {c.companyName}
                  </span>
                  {isSelected && (
                    <span className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: 'rgb(18,76,114)' }}>
                      <svg className="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                      </svg>
                    </span>
                  )}
                </div>

                {/* Department */}
                <p className="text-xs text-gray-500 truncate mt-0.5">{c.department_name}</p>

                {/* Role + Default badges */}
                <div className="flex items-center gap-1.5 mt-1.5 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded-full font-medium"
                    style={{
                      backgroundColor: isSelected ? 'rgba(18,76,114,0.12)' : 'rgba(0,0,0,0.06)',
                      color: isSelected ? 'rgb(18,76,114)' : '#555'
                    }}>
                    {c.role}
                  </span>
                  {c.is_default && (
                    <span className="text-xs px-2 py-0.5 rounded-full font-medium"
                      style={{ backgroundColor: 'rgba(18,76,114,0.08)', color: 'rgb(18,76,114)' }}>
                      ★ Default
                    </span>
                  )}
                </div>
              </div>
            </button>
          </li>
        );
      })}

      {/* Logout — QA / dev only (production uses silent SSO, no manual logout) */}
      {!isProduction() && (
        <li>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 text-sm transition-all hover:bg-red-50 text-left"
            style={{ color: '#dc2626' }}
          >
            <span className="w-7 h-7 rounded-full flex items-center justify-center text-xs"
              style={{ backgroundColor: 'rgba(220,38,38,0.08)' }}>⎋</span>
            <span className="font-medium">Logout</span>
          </button>
        </li>
      )}

    </ul>
  </div>
)}
            </div>
          )}
        </header>

<div className="md:px-[2.5%] 3xl:px-[8%] 4xl:px-[10%] ">
  
{headerText && (
 <div className={`px-4 sm:px-0 py-4 sm:py-6 md:py-8 mt-2 sm:mt-4 md:mt-6 lg:mt-6 lg:mb-0 ${extraMb ? 'xl:mb-20' : ''} max-w-full z-10 text-white`}>
      <h1 className="text-white font-bold text-lg sm:text-2xl md:text-3xl lg:text-4xl drop-shadow-lg break-words">
        {headerText}
      </h1>
      <p className="text-white text-xs sm:text-base md:text-lg mt-1 sm:mt-2 drop-shadow-md break-words">
        {headerpage}
      </p>
    </div>
  )}
</div>

      </div>

      {/* Spacer so page content starts below header */}
      {/* <div className="pt-16 sm:pt-16 md:pt-16 lg:pt-24"></div> */}
    </div>
  );
};

export default Header;
